<template>
<div class="container-fluid">

    <page-loading v-if="!data_loaded" />

	<div v-else class="row">
		<div class="col-md-8 offset-md-2">
			<h1>Task Manager</h1>
		</div>

		<div class="col-md-8 offset-md-2">

	        <div class="card">
	            <div class="card-body">
	                <div class="section-label">New Task</div>
	                <div class="d-flex flex-fill">
	                    <div class="input-group mr-2 flex-grow-1">
	                        <input class="form-control" v-model="task.title" placeholder="Title">
	                        <div class="input-group-append">
	                            <div class="input-group-text btn btn-light" @click="toggleOptions()"><i class="fal fa-cog"></i></div>
	                        </div>  
	                    </div>                    
	                    <date-picker
                            readonly="true"
	                    	class="date-picker"
	                        v-model="task.due_date"
	                        :config="config.datePickerOptions"
	                        input-class="form-control bg-white" placeholder="Due Date" />                  
	                </div>

	                <div v-if="options" class="d-flex flex-fill mt-2"> 
	                    <div class="w-50 mr-2">
	                        <label class="text-gray-500 mb-0">Change type</label>                   
	                        <v-select                            
	                            :options="task_types"
	                            :reduce="task_type => task_type.value"
	                            v-model="task.type"
	                            :clearable="false"  />  
	                    </div>

	                    <div class="w-50">
	                        <label class="text-gray-500 mb-0">Tag provider</label>   
	                        <v-select 
	                            label="display_name"
	                            :options="allProviderIds"
	                            v-model="provider" /> 
	                    </div>  
	                </div>

                    <div class="d-flex flex-row-reverse mt-2">
                        <button class="btn btn-primary text-nowrap" @click="addTask()">Save Task</button>
                    </div>  
	            </div>
	        </div>

	    	<div class="card">
	            <div class="card-header">Today's Tasks</div>
	            <ul v-if="todayTasks.length" class="list-group list-group-flush">
	                <task v-for="task in todayTasks"
	                    :key="task.id"
	                    :task="task"
	                    :task_types="task_types"
	                    :show_edit="true"
	                    @status-changed="changeStatus($event)"
	                    @task-updated="updateTask($event)"
	                    @task-deleted="deleteTask($event)">  
	                </task>            
	            </ul>
	            <div v-else class="text-gray-500 text-center text-2xl p-3">
	                <i class="fas fa-umbrella-beach rounded-circle text-white" style="background:#bf5ea9; width:3rem; height:3rem; line-height:3rem;"></i>
	                <div class="mt-2">Woohoo! You're all caught up for the day.</div>
	            </div>
	        </div>

	        <div class="card">
	            <div class="card-header">Upcoming Tasks</div>
	            <ul v-if="upcomingTasks.length" class="list-group list-group-flush">
	                <task v-for="task in upcomingTasks"
	                    :key="task.id"
	                    :task="task"
	                    :task_types="task_types"
	                    :show_edit="true"
	                    @status-changed="changeStatus($event)"
	                    @task-updated="updateTask($event)"
	                    @task-deleted="deleteTask($event)">  
	                </task>  
	            </ul>
	            <div v-else class="text-gray-500 text-center text-2xl p-3">
	                <i class="fas fa-sun rounded-circle text-white" style="background:#bf5ea9; width:3rem; height:3rem; line-height:3rem;"></i>
	                <div class="mt-2">Nothing but clear skies.</div>
	            </div>
	        </div>

	        <div v-if="completedTasks.length" class="card">
	            <div class="card-header">Completed Tasks</div>
	            <ul class="list-group list-group-flush">
	                <task v-for="task in completedTasks"
	                    :key="task.id"
	                    :task="task"
	                    :task_types="task_types"
	                    :show_edit="true"
	                    @status-changed="changeStatus($event)"
	                    @task-updated="updateTask($event)"
	                    @task-deleted="deleteTask($event)">   
	                </task>
	            </ul>
	        </div>

		</div>
	</div>
</div>
</template>

<script>

	import { mapGetters, mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
    import Task from '../../components/Task';

    export default {
        mixins: [BreadcrumbsManager],
        
        components: {
            Task,
        },

        data() {
            return {
                options: false,
                current: moment(),
                all_tasks: [],

                data_loaded: false,
                task_types: [
                    { 'label': 'Task', 'value': 'task' },
                    { 'label': 'Follow up', 'value': 'follow_up' },
                ],

                task: {
                },

                provider: {
                },

            }
        },

        created() {
        	this.fetchTasks();
            this.task = {
				title: '',
				due_date: '',
				type: 'task',
				status: 0,
				user_id: this.user.id,
				client_id: this.user.client_id,
                taskable: {
                }
			};

        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Task Manager', to: { name: 'tasks'} },
            ]); 
        },

        mounted() {
            /* Axios Success Interceptor */
            axios.interceptors.request.use(
            function axiosRequestInterceptor(request) {
                if(request.data) {
                    Object.keys(request.data).forEach(e => {
                        if(request.data[e] instanceof Date) {
                            request.data[e] = moment(request.data[e]).format('YYYY-MM-DD');
                        }
                    });
                }
                return request;
            });
        },

        methods: {
        	addTask() {
        		axios.post('/api/tasks/store', this.task).then(({data}) => {
					this.all_tasks.push(data);

					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 3000,
						icon: 'success',
						title: 'Task saved',
					});

					this.task.title = '';
					this.task.due_date = '';
					this.task.taskable_id = '';
                    this.provider = {};
                })
        	},

        	fetchTasks() {
        		axios.get('/api/tasks').then(({data}) => {
        			this.all_tasks = data;
        			this.data_loaded = true;
        		});
        	},

            toggleOptions() {
                this.options = !this.options;
                this.task_type = { 'label': 'Task', 'value': 'task' };
            },

            changeStatus($event) {
                axios.put('/api/tasks/' + $event.id + '/status', $event).then(({ data }) => { 
					//update the task in the list
					let index = this.all_tasks.map(task => { return task.id; }).indexOf($event.id);
					this.all_tasks[index].status = $event.status;
                })              
            },

            updateTask($event) {
                //$event.due_date = $event.due_date_new;
                axios.put('/api/tasks/' + $event.id, $event).then(({data}) => {
					let index = this.all_tasks.map(task => { return task.id; }).indexOf($event.id);
					this.all_tasks[index].title = data.title;
					this.all_tasks[index].due_date = data.due_date;
                    this.all_tasks[index].taskable = data.taskable ? data.taskable : null;
                })
            },

            deleteTask($event) {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this task!',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete task',
                      cancelButtonText: 'Keep task',
                      animation: false,
                    }).then((result) => {
						if (result.value) {
                            axios.delete('/api/tasks/' + $event, $event).then(() => {
								let index = this.all_tasks.map(task => { return task.id; }).indexOf($event);
								this.all_tasks.splice(index, 1);
                            })
                        }
                    }
                );
            },
        },

        computed: {
            ...mapGetters(['allProviderIds']),
        	...mapState(['config', 'perms', 'user']),

            todayTasks() {
                return _.orderBy(
                    this.all_tasks.filter(task => {
                        return (moment(task.due_date).diff(this.current, 'days') <= 1) && (task.status == 0);
                    }),
                    'due_date', 'asc');                    
            },

            upcomingTasks() {
                return _.orderBy(
                    this.all_tasks.filter(task => {
                        return ((moment(task.due_date).diff(this.current, 'days') > 1) && (task.status == 0)) || !task.due_date;
                    }),
                    'due_date', 'asc');     
            },

            completedTasks() {
                return _.orderBy(
                    this.all_tasks.filter(task => {
                        return task.status > 0;
                    }),
                    'updated_at', 'desc');
            },
        },  

        watch: {
            provider() {
                this.task.taskable = {
                    morphable_id:    this.provider ? this.provider.morphable_id : null,
                    morphable_type:  this.provider ? this.provider.morphable_type : null,
                };
            }
        }    

    }
</script>

<style scoped>
	.date-picker { width: 110px !important; }
    .complete { text-decoration:line-through; }

    .check-me { position:relative; }
    .check-me i { cursor:pointer; }


    /* hide impossibles */
    .incomplete .check-me i.ignored { display:none; }
    .complete .check-me i.incomplete { display:none; }
    .complete .check-me i.hovering { display:none; }

    /* hide ignored by default, re-enabled explicitly */
    .complete .check-me i.ignored { display:none; }
    .complete .check-me.ignored i.ignored { display:block; text-decoration:none !important; }
    .complete .check-me.ignored i.completed { display:none; }

    /* hover effects */
    .incomplete .check-me .completed { opacity:0; transition:.2s all ease-in; position:absolute; top:0; left:0; }
    .incomplete .check-me .hovering { opacity:0; transition:.2s all ease-in; position:absolute; top:0; left:0; }
    
    .incomplete .check-me:hover .hovering { opacity:1; transition:.2s all ease-in; }

    /* click effects */
    .incomplete .check-me:active .completed { opacity:1; color:green; }
    .incomplete .check-me:active .hovering { opacity:0; }
    .complete .check-me:active .completed { opacity:0; }
    .complete .check-me:active .incomplete { opacity:1; display:block; position:absolute; top:0; left:0; }
/*    .check-me i.fa-check-circle { opacity:0; transition:.2s all ease-in; position:absolute; top:0; left:0; }
    .check-me:hover i.fa-check-circle { opacity:1; transition:.2s all ease-in }
    .check-me:hover i.fa-circle { opacity:0; transition:.2s all ease-in; }

    .complete { text-decoration:line-through; }
    .complete i.fa-check-circle, .complete i.fa-check-times { opacity:1; }
    .complete i.fa-circle { opacity:0; }*/
</style>